<template>
  <div>
    <section id="page-title">
      <div class="container clearfix">
        <h1>ติดต่อเรา</h1>
        <br />
        <br />
        <!-- <span>Get in Touch with Us</span> -->
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#">Home</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">ติดต่อเรา</li>
        </ol>
      </div>
    </section>
    <!-- #page-title end -->

    <section id="content">
      <div class="content-wrap">
        <div class="container clearfix">
          <!-- Contact Form
          =============================================-->
          <div class="col-12">
            <!-- Contact Info
            =============================================-->

            <div class="row clear-bottommargin">
              <div class="col-5">
                <img
                  src="assets/icon/request.png"
                  style="width: 50%; margin: 0 0 0 auto;
							display: block;"
                />
              </div>
              <div class="col-6 adminword">
                ติดตามชุดสวยอัพเดตใหม่ และสอบถามรายละเอียด
                <br />แอดมินของเรายินดีให้บริการ
              </div>

              <div class="col-lg-4 col-md-6 bottommargin clearfix">
                <div class="feature-box fbox-center fbox-bg fbox-plain">
                  <div class="fbox-icon">
                    <a href="#">
                      <i class="icon-phone3"></i>
                    </a>
                  </div>
                  <h3>
                    Line
                    <span class="subtitle">@wintershopthailand</span>
                  </h3>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 bottommargin clearfix">
                <div class="feature-box fbox-center fbox-bg fbox-plain">
                  <div class="fbox-icon">
                    <a href="#">
                      <i class="icon-skype2"></i>
                    </a>
                  </div>
                  <h3>
                    Facebook
                    <span class="subtitle">facebook.com/wintershopthailand</span>
                  </h3>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 bottommargin clearfix">
                <div class="feature-box fbox-center fbox-bg fbox-plain">
                  <div class="fbox-icon">
                    <a href="#">
                      <i class="icon-twitter2"></i>
                    </a>
                  </div>
                  <h3>
                    Follow on instragram
                    <span class="subtitle">Instagram.com/wintershopthailand</span>
                  </h3>
                </div>
              </div>
            </div>
            <!-- Contact Info End -->
          </div>
          <!-- Contact Form End -->
        </div>

        <div class="container clearfix">
          <div class="fancy-title title-dotted-border" style="margin-top: 20px;">
            <h3>สาขาลาดพร้าว</h3>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6" style="font-size: 20px;">
                <u>เปิดบริการ</u>
                <br />11.00 - 20.00 น.
                <br />ทุกวันอังคาร - วันอาทิตย์ (หยุดวันนัขตฤกษ์)
                <br />โทร. 097-210-1000
                <br />
                <!-- <u>Google Map</u>
                <a href="https://bit.ly/2Mof6AW">https://bit.ly/2Mof6AW</a> -->
              </div>
              <div class="col-6">
                <u>รูปแผนที่</u>
                <img src="assets/map/Lat Prow.jpg" width="70%" />
              </div>
            </div>
          </div>
        </div>

        <!-- Google Map
        =============================================-->
        <!-- <div class="col-12 col_last">

						<section id="google-map" class="gmap" style="height: 410px;">
						
						</section>

        </div>-->
        <!-- Google Map End -->

        <div class="container clearfix">
          <div class="fancy-title title-dotted-border">
            <h3>สาขาเมืองทอง</h3>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-6" style="font-size: 20px;">
                <u>เปิดบริการ</u>
                <br />11.00 - 20.00 น.
                <br />ทุกวันอังคาร - วันอาทิตย์ (หยุดวันนัขตฤกษ์)
                <br />โทร. 097-210-1000
                <br />
                <u>Google Map</u>
                <a href="https://bit.ly/2Mof6AW">https://bit.ly/2Mof6AW</a>
              </div>
              <div class="col-6">
                <img src="assets/map/MaeungThong.jpg" width="70%" />
              </div>
            </div>
          </div>
        </div>

        <!-- Google Map
        =============================================-->
        <!-- <div class="col-12 col_last">

							<section id="google-map" class="gmap" style="height: 410px;">
							
							</section>
	
        </div>-->
        <!-- Google Map End -->
      </div>
      <div class="clear"></div>
    </section>
    <!-- #content end -->
  </div>
</template>
<script>
// import store from "@/store.js";
export default {
  props: ["msg"],
  data() {
    return {
      welcome: "This is your profile"
    };
  },
  methods: {
    welcomeMessage() {}
  },
  components: {}
};
</script>
 
<style >
</style>